import Vue from 'vue';
import Tooltip from './main.vue';

export default Vue.extend(Tooltip);
